import Colors from 'Theme/Colors'
import Styles from './ChargerSpecsEdit.module.css'
import React, {
  useImperativeHandle,
  useRef,
  forwardRef,
  useEffect,
  useState,
} from 'react'
import { TariffContainer } from 'Containers'
import { IFText } from 'Components'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import InfinityEnums from 'Enums/InfinityEnums'
import { connect } from 'react-redux'
import OperatorUserActions from 'Stores/OperatorUser/Actions'
import ChargePointActions from 'Stores/ChargePoint/Actions'
import PropTypes from 'prop-types'

const ListContainer = styled.div`
  box-shadow: 0px 0px 4px ${Colors.ChargePointSpecsEdit.ListBoxShadow};
  border-radius: 5px;
`

const ChargerSpecsEdit = forwardRef(
  (
    {
      className,
      isActivated,
      chargePointId,
      fetchChargePointTariffsList,
      fetchTariffsList,
    },
    ref,
  ) => {
    const { t } = useTranslation()
    const refDiv = useRef()
    const chargePointTariffsRef = useRef()
    const [height, setHeight] = useState(0)

    const handleCancel = () => {
      chargePointTariffsRef?.current?.handleCancel()
    }
    const handleSubmit = () => {
      chargePointTariffsRef?.current?.handleSubmit(false)
    }

    const didChange = () => {
      const tariffsChanged = chargePointTariffsRef?.current?.didChange()
      return tariffsChanged
    }

    useImperativeHandle(ref, () => ({
      handleCancel,
      handleSubmit,
      didChange,
    }))

    useEffect(() => {
      // max list height container height - padding,title,add button
      setHeight(refDiv.current.getBoundingClientRect().height - 140)
    }, [refDiv])

    useEffect(() => {
      if (!isActivated && chargePointId) {
        fetchChargePointTariffsList(chargePointId)
        fetchTariffsList()
      }
    }, [isActivated])

    return (
      <div className={`${Styles.Container} ${className}`} ref={refDiv}>
        <div className={Styles.ListTitleContainer}>
          <div className={Styles.TitleContainer}>
            <IFText className={Styles.Title} style={{ color: Colors.black }}>
              {t('ChargePointSpecsEdit.Tariffs')}
            </IFText>
          </div>
          <ListContainer className={Styles.TariffList}>
            <TariffContainer
              key={'ChargerSpecsEdit ChargePointTariffList'}
              ref={chargePointTariffsRef}
              renderFor={InfinityEnums.ChargePointSpecsContainer.CHARGEPOINT}
              isEditing
              maxListHeight={height}
            />
          </ListContainer>
        </div>
      </div>
    )
  },
)

ChargerSpecsEdit.propTypes = {
  className: PropTypes.object,
  isActivated: PropTypes.bool,
  chargePointId: PropTypes.string,
  fetchChargePointTariffsList: PropTypes.func,
  fetchTariffsList: PropTypes.func,
}

function mapDispatchToProps(dispatch) {
  return {
    fetchChargePointTariffsList: (chargePointId) =>
      dispatch(ChargePointActions.fetchChargePointTariffsList(chargePointId)),
    fetchTariffsList: () => dispatch(OperatorUserActions.fetchTariffsList()),
  }
}

export default connect(null, mapDispatchToProps, null, {
  forwardRef: true,
})(ChargerSpecsEdit)
